import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom"; // updated

import {
  Row,
  Col,
  Button,
  Container,
  Spinner,
  ListGroup,
} from "react-bootstrap";
import { NoData } from "../../components/no-data/NoData";

import DefaultLayout from "../../components/layout/DefaultLayout";
import { fetchSingleAmbassadorAction } from "../ambassador/ambassadorAction";
import { ReferralCodeTable } from "../../components/referral-code/ReferralCodeTable";

const AmbassadorLanding = () => {
  const { _id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate(); // updated

  const { selectedAmbassador, isLoading } = useSelector(
    (state) => state.ambassadorUser
  );

  useEffect(() => {
    if (_id) dispatch(fetchSingleAmbassadorAction(_id));
  }, [_id, dispatch]);

  // If no ambassador data, show NoData component
  if (!selectedAmbassador?._id) {
    return <NoData />;
  }

  const ambassadorId = selectedAmbassador._id;

  return (
    <DefaultLayout>
      <Container className="page-lead">
        <Row>
          <Col>
            <Button
              variant="outline-secondary"
              onClick={() => navigate("/ambassadors")} // updated
            >
              &lt; Back
            </Button>
            <hr />
            <h5 className="mt-5">Ambassador Info</h5>
            {isLoading && <Spinner animation="border" />}
          </Col>
        </Row>

        <Row>
          <Col>
            <ListGroup>
              <ListGroup.Item>
                Full Name:{" "}
                <b>
                  {selectedAmbassador.fName} {selectedAmbassador.lName}
                </b>
              </ListGroup.Item>
              <ListGroup.Item>
                Mobile: <b>{selectedAmbassador.mobile}</b>
              </ListGroup.Item>
              <ListGroup.Item>
                Email: <b>{selectedAmbassador.email}</b>
              </ListGroup.Item>
              <ListGroup.Item>
                Company: <b>{selectedAmbassador.company}</b>
              </ListGroup.Item>
              <ListGroup.Item>
                Website:{" "}
                <b>
                  <a
                    href={selectedAmbassador.websiteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {selectedAmbassador.websiteLink}
                  </a>
                </b>
              </ListGroup.Item>
              <ListGroup.Item>
                Social Link: <b>{selectedAmbassador.SocialLink}</b>
              </ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col>
            <h5>Referral Codes</h5>
            <ReferralCodeTable ambassadorId={ambassadorId} />
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  );
};

export default AmbassadorLanding;
